import { useEffect, useId, useState } from "react";
import { request } from "../api/client";
import { ErrorNotice } from "../components/AdminFeedback";
import { FieldRequirement } from "../components/FieldRequirement";
import { AppSelect } from "../components/inputs/AppSelect";
import { useLocale } from "../i18n";

type Party = { partyId: string; name: string };
export function TeamAffiliationPicker({ unitId, value, onChange }: {
  unitId: string; value: string; onChange: (value: string) => void;
}) {
  const { w } = useLocale(); const id = useId();
  const [search, setSearch] = useState(""); const [cursor, setCursor] = useState("");
  const [items, setItems] = useState<Party[]>([]); const [next, setNext] = useState<string>();
  const [error, setError] = useState<unknown>(); const [revision, refresh] = useState(0);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const controller = new AbortController(); setError(undefined); setLoading(true);
    const timer = setTimeout(() => {
      const query = new URLSearchParams({ unitId, limit: "50" });
      if (search.trim()) query.set("search", search.trim());
      if (cursor) query.set("cursor", cursor);
      request<{ items: Party[]; nextCursor?: string }>("/events/eventTeamAffiliations?" + query, "GET", undefined, controller.signal)
        .then(data => { if (!controller.signal.aborted) { setItems(previous => [...new Map([...(cursor ? previous : previous.filter(p => p.partyId === value)), ...data.items].map(p => [p.partyId, p])).values()]); setNext(data.nextCursor); } })
        .catch(e => { if (!controller.signal.aborted) setError(e); })
        .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    }, 200);
    return () => { clearTimeout(timer); controller.abort(); };
  }, [unitId, search, cursor, revision]);
  return <div className="event-affiliation-picker">
    <label htmlFor={id}><span className="field-caption">{w("الجهة التابع لها الفريق", "Team affiliation")} <FieldRequirement required={false} /></span></label>
    <AppSelect id={id} value={value} loading={loading} aria-describedby={`${id}-help`}
      onSearch={text => { setSearch(text.slice(0, 100)); setCursor(""); setNext(undefined); setItems(previous => previous.filter(p => p.partyId === value)); }}
      onChange={selected => { if (!selected || items.some(p => p.partyId === selected)) onChange(selected); }}>
      <option value="">{w("دون جهة تابعة", "No affiliation")}</option>
      {items.map(p => <option key={p.partyId} value={p.partyId}>{p.name}</option>)}
    </AppSelect>
    <small id={`${id}-help`} className="event-field-help">{w("اختر جهة مسجلة من القائمة. يمكنك الكتابة داخل القائمة للبحث؛ الكتابة وحدها لا تُعيّن جهة للفريق.", "Select a registered organization from the list. Type inside the list to search; typing alone does not assign an affiliation.")}</small>
    <ErrorNotice operation="read" error={error} retry={() => refresh(n => n + 1)} />
    {next && <button type="button" className="text-button" disabled={loading} onClick={() => setCursor(next)}>{w("عرض جهات أخرى", "More organizations")}</button>}
  </div>;
}
